import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getPersonCategories() {
  try {
    return await apiFetch<any[]>('/api/person-categories');
  } catch {
    return [];
  }
}

export async function getPersonCategoryById(id: string) {
  try {
    return await apiFetch<any>(`/api/person-categories/${id}`);
  } catch {
    return null;
  }
}

export async function createPersonCategory(data: any) {
  return apiPost('/api/person-categories', data);
}

export async function updatePersonCategory(id: string, data: any) {
  return apiPut(`/api/person-categories/${id}`, data);
}

export async function deletePersonCategory(id: string) {
  return apiDelete(`/api/person-categories/${id}`);
}
